import marquee from 'vanilla-marquee';

function animateProductGridBannerText() {
  // const bannerTopText = document.querySelector('.product-grid__banner__top-text');
  // if (bannerTopText) {
  //     new marquee (bannerTopText, {
  //         direction: 'left',
  //         duration: 25000,
  //         duplicated: true,
  //         gap: 30,
  //         startVisible: true
  //     });
  // }
}

export { animateProductGridBannerText as default };
